import { createFetchedDataRecord, updateObject } from '@vista-digital/utilities';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { loyaltyDomainStore } from '../../../store';
export const loadMemberRewards = async (reloadCachedData = false) => {
    if (!isMemberSignedIn())
        throw Error('Cannot load member rewards when user is not signed in.');
    const state = loyaltyDomainStore.data.memberRewards;
    return await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.members.rewards.getAll,
        state,
        cacheDuration: getCacheDuration('member'),
        reloadCachedData,
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { memberRewards, relatedData } = response;
    assignRelatedData(relatedData, cacheDuration);
    return memberRewards;
};
const assignRelatedData = (relatedData, cacheDuration) => {
    const { rewards, items } = relatedData;
    updateObject(loyaltyDomainStore.data.rewardsById, createFetchedDataRecord(rewards, 'id', cacheDuration));
    updateObject(loyaltyDomainStore.data.itemsById, createFetchedDataRecord(items, 'id', cacheDuration));
};
//# sourceMappingURL=load-member-rewards.js.map